import { useState, useEffect } from 'react'
import { Header } from './components/layout/Header'
import { Footer } from './components/layout/Footer'
import { Hero } from './components/sections/Hero'
import { AboutUs } from './components/sections/AboutUs'
import { Challenge } from './components/sections/Challenge'
import { Services } from './components/sections/Services'
import { Methodology } from './components/sections/Methodology'
import { Leaders } from './components/sections/Leaders'
import { Contact } from './components/sections/Contact'
import { PrivacyPolicy } from './components/sections/PrivacyPolicy'
import { SectionAnalytics } from './components/analytics/SectionAnalytics'

function App() {
    const [currentPage, setCurrentPage] = useState<'home' | 'privacy'>('home')

    useEffect(() => {
        // Check initial URL
        const checkPage = () => {
            if (window.location.pathname === '/politica-privacidade' ||
                window.location.hash === '#politica-privacidade') {
                setCurrentPage('privacy')
                window.scrollTo(0, 0)
            } else {
                setCurrentPage('home')
            }
        }

        checkPage()

        // Listen for URL changes
        window.addEventListener('popstate', checkPage)
        window.addEventListener('hashchange', checkPage)

        return () => {
            window.removeEventListener('popstate', checkPage)
            window.removeEventListener('hashchange', checkPage)
        }
    }, [])

    // Handle link clicks for privacy policy AND navigation back to home with hash
    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement
            const anchor = target.closest('a')
            if (!anchor) return

            const href = anchor.getAttribute('href')

            // Handle privacy policy link
            if (href === '/politica-privacidade') {
                e.preventDefault()
                setCurrentPage('privacy')
                window.history.pushState({}, '', '/politica-privacidade')
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
                }, 0)
                return
            }

            // Handle home links with hash (e.g., /#quem-somos)
            if (href?.startsWith('/#')) {
                e.preventDefault()
                const hash = href.substring(1) // Remove leading /
                setCurrentPage('home')
                window.history.pushState({}, '', '/')
                // Wait for React to render home page, then scroll to section
                setTimeout(() => {
                    const element = document.querySelector(hash)
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' })
                    }
                }, 100)
            }
        }

        document.addEventListener('click', handleClick)
        return () => document.removeEventListener('click', handleClick)
    }, [])

    return (
        <div className="min-h-screen bg-dpxp-light">
            {/* Navigation */}
            <Header />

            {/* Main Content */}
            <main>
                {currentPage === 'privacy' ? (
                    <PrivacyPolicy />
                ) : (
                    <>
                        {/* Analytics Tracking */}
                        <SectionAnalytics />

                        {/* Hero Section */}
                        <Hero />

                        {/* Quem Somos */}
                        <AboutUs />

                        {/* O Desafio na Saúde */}
                        <Challenge />

                        {/* Soluções */}
                        <Services />

                        {/* Metodologia */}
                        <Methodology />

                        {/* Líderes */}
                        <Leaders />

                        {/* Contato */}
                        <Contact />
                    </>
                )}
            </main>

            {/* Footer */}
            <Footer />
        </div>
    )
}

export default App
